import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SubmitActivityFeedbackUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(activityUuid: string, comment: string): Promise<SATResult<void, SATError>> {
    return this.prescriptionRepo.submitActivityFeedback(activityUuid, comment);
  }
}
